
import EventItemForm from '@/components/event-flow/EventItemForm.vue';
import { ApiError } from '@/model/ApiError';
import {
    CreateEventFlowItem,
    EventFlowItem,
    UpdateEventFlowItem,
} from '@/model/event-flow/EventFlow';
import { Responsible } from '@/model/Responsible';
import { Topic } from '@/model/Topic';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { mapActions, mapGetters, mapMutations } from 'vuex';

@Component({
    components: {
        EventItemForm,
    },
    computed: {
        ...mapGetters({
            responsibles: 'responsibleStorage/getResponsibles',
            locations: 'locationsStorage/getLocations',
            topics: 'topicsStorage/getTopics',
            error: 'eventFlowStorage/getError',
        }),
    },
    methods: {
        ...mapMutations({
            setError: 'eventFlowStorage/setError',
        }),
        ...mapActions({
            create: 'eventFlowStorage/createItem',
            update: 'eventFlowStorage/updateItem',
            delete: 'eventFlowStorage/deleteItem',
            fetchLocations: 'locationsStorage/fetchLocations',
            fetchResponsibles: 'responsibleStorage/fetchResponsibles',
            fetchTopics: 'topicsStorage/fetchTopics',
        }),
    },
})
export default class EventItemModal extends Vue {
    @Prop({ default: {} as EventFlowItem }) item!: EventFlowItem;
    @Prop(Date) readonly maxDateTime!: Date;

    loading = false;

    create!: (request: CreateEventFlowItem) => Promise<void | EventFlowItem>;

    update!: (request: UpdateEventFlowItem) => Promise<void | EventFlowItem>;

    delete!: (request: UpdateEventFlowItem) => Promise<void>;

    setError!: (error: ApiError | null) => void;

    locationsLoading = true;

    fetchLocations!: (eventId: number) => Promise<void | Location[]>;

    locations!: Location[] | null;

    responsiblesLoading = true;

    fetchResponsibles!: (eventId: number) => Promise<void>;

    responsibles!: Responsible[];

    topicsLoading = true;

    fetchTopics!: (eventId: number) => Promise<void | Topic[]>;

    topics!: Topic[] | null;

    get eventId(): number {
        return parseInt(this.$route.params.id, 10);
    }

    mounted(): void {
        this.fetchLocations(this.eventId).finally(() => {
            this.locationsLoading = false;
        });

        this.fetchResponsibles(this.eventId).finally(() => {
            this.responsiblesLoading = false;
        });

        this.fetchTopics(this.eventId).finally(() => {
            this.topicsLoading = false;
        });
    }

    destroyed(): void {
        this.setError(null);
    }

    @Emit()
    close(): void {
        // close
    }

    @Emit()
    success(type: string): string {
        return type;
    }

    onSubmit(item: EventFlowItem): void {
        this.loading = true;

        if (item.id) {
            this.update({ eventId: this.eventId, item })
                .then(() => {
                    this.success('updated');
                })
                .finally(() => {
                    this.loading = false;
                });
        } else {
            this.create({ eventId: this.eventId, item })
                .then(() => {
                    this.success('created');
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    onDelete(item: EventFlowItem): void {
        this.loading = true;
        this.delete({ eventId: this.eventId, item })
            .then(() => {
                this.success('deleted');
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
